module.exports = __webpack_public_path__ + "static/img/ty.77f67b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ty.png
// module id = oLV1
// module chunks = 0